import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilClearAll, cilCopy, cilInfo, cilPencil, cilReload } from '@coreui/icons'
import moment from 'moment'
import SearchTable from 'src/components/searchTable'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { AFFILIATES_API, ROLE_LIST_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import AffiliatesCreationModal from './affiliatesCreationModal'
import { Link, useHistory } from 'react-router-dom'
import ResetPasswordModal from '../userManagement/common/resetPasswordModal'

const Affiliates = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const { userSessionObj, userObj } = useContext(GlobalContext)
  const [openModal, setOpenModal] = useState(false)
  const [selectedAffiliate, setSelectedAffiliate] = useState('')
  const [affiliates, setAffiliates] = useState([])
  const [affiliateStatusModal, setAffiliateStatusModal] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = useState(false)
  const history = useHistory()

  const createAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.AFFILIATES.CREATE,
  )
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.AFFILIATES.UPDATE,
  )

  const [{ data: affiliatesDataList, loading: affiliatesDataLoading }, getAffiliateCall] = useAxios(
    {
      url: AFFILIATES_API,
      method: 'get',
    },
  )

  const [{ data: createAffiliate, loading: createAffiliateLoading }, affiliateCreateCall] =
    useAxios(
      {
        url: AFFILIATES_API,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: updateAffiliate, loading: updateAffiliateLoading }, affiliateUpdateCall] =
    useAxios(
      {
        url: AFFILIATES_API,
        method: 'put',
      },
      { manual: true },
    )

  const [
    { data: updateAffiliateStatus, loading: updateAffiliateStatusLoading },
    affiliateUpdateStatusCall,
  ] = useAxios(
    {
      url: AFFILIATES_API + '/update-status',
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: roleList, loading: roleListLoading }] = useAxios({
    url: ROLE_LIST_API,
    method: 'get',
  })

  useEffect(() => {
    if (affiliatesDataList && affiliatesDataList.success) {
      if (userObj.user_type === 'AFFILIATES_MARKETING') {
        console.log('here', userObj)
        const affiliate = affiliatesDataList.data.filter((item) => item.user_id === userObj._id)[0]
        history.push(`/affiliates/detail/${affiliate._id}`)
      }
      setAffiliates(affiliatesDataList.data)
    }
  }, [affiliatesDataList])

  useEffect(() => {
    setLoader(
      affiliatesDataLoading ||
        createAffiliateLoading ||
        updateAffiliateLoading ||
        roleListLoading ||
        updateAffiliateStatusLoading,
    )
  }, [
    affiliatesDataLoading,
    createAffiliateLoading,
    updateAffiliateLoading,
    roleListLoading,
    updateAffiliateStatusLoading,
  ])

  useEffect(() => {
    getAffiliateCall()
  }, [])

  useEffect(() => {
    if (createAffiliate && createAffiliate.success) {
      getAffiliateCall()
      raiseToast('success', 'Affiliate created successfully')
    }
  }, [createAffiliate])

  useEffect(() => {
    if (updateAffiliate && updateAffiliate.success) {
      getAffiliateCall()
      raiseToast('success', 'Affiliate updated successfully')
    }
  }, [updateAffiliate])

  useEffect(() => {
    if (updateAffiliateStatus && updateAffiliateStatus.success) {
      getAffiliateCall()
      raiseToast('success', 'Affiliate updated successfully')
    }
  }, [updateAffiliateStatus])

  const handleStatus = async (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setAffiliateStatusModal(false)
    affiliateUpdateStatusCall({
      params: {
        affiliate_id: info._id,
      },
      data: {
        status: !info.status,
        user_id: info.user_id,
      },
    })
  }
  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedAffiliate(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedAffiliate({})
    setOpenModal(!openModal)
  }

  const addAffiliates = (payload) => {
    affiliateCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editAffiliates = (payload, id) => {
    affiliateUpdateCall({
      params: {
        affiliate_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  const handleCopyClick = (copyText) => {
    copyTextToClipboard(copyText)
      .then(() => {
        raiseToast('success', 'Link copied')
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getRoleList = () => {
    return roleList.data
      .filter(
        (item) => item.isActive || (item.name !== 'Subscriber' && item.name !== 'Account Admin'),
      )
      .map((item) => ({ id: item._id, name: item.name }))
  }

  const handleActivateDeactivate = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedAffiliate(info)
    setAffiliateStatusModal(true)
  }

  const handleResetPassword = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedAffiliate(info)
    setResetPasswordModal(true)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => <Link to={`/affiliates/detail/${info._id}`}>{info.name}</Link>,
      width: 15,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email,
      width: 20,
    },
    {
      header: 'Mobile',
      dataCell: (info) => info.mobile,
      width: 14,
    },
    {
      header: 'Affiliate Code',
      dataCell: (info) => info.code,
      width: 13,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 13,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 16,
    },
    {
      header: (
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />
        </div>
      ),
      dataCell: (info) => (
        <div className="d-flex justify-content-center">
          <CDropdown>
            <CDropdownToggle color="white" caret={false}>
              <FontAwesomeIcon icon={faEllipsisH} size="2x" />
            </CDropdownToggle>
            <CDropdownMenu>
              {info.status && (
                <CDropdownItem onClick={() => history.push(`/affiliates/detail/${info._id}`)}>
                  <CIcon icon={cilInfo} size="sm" />
                  {' View Details'}
                </CDropdownItem>
              )}
              {info.status && (
                <CDropdownItem
                  onClick={() =>
                    handleCopyClick(`${accountObj.domain_name}/signup?referral_code=${info.code}`)
                  }
                >
                  <CIcon icon={cilCopy} size="sm" />
                  {'  Copy Signup Link'}
                </CDropdownItem>
              )}
              {userObj.user_type !== 'AFFILIATES_MARKETING' && info.status && (
                <CDropdownItem onClick={() => handleEdit(info)}>
                  <CIcon icon={cilPencil} size="sm" />
                  {'  Edit'}
                </CDropdownItem>
              )}
              <CDropdownItem onClick={() => handleResetPassword(info)}>
                <CIcon icon={cilReload} size="sm" />
                {'  Reset Password'}
              </CDropdownItem>
              {userObj.user_type !== 'AFFILIATES_MARKETING' && (
                <CDropdownItem onClick={() => handleActivateDeactivate(info)}>
                  <CIcon icon={cilClearAll} size="sm" />
                  {!info.status ? ' Activate' : ' Deactivate'}
                </CDropdownItem>
              )}
            </CDropdownMenu>
          </CDropdown>
        </div>
      ),
      width: 10,
    },
  ]

  return (
    <>
      <h4>{'Affiliates'}</h4>
      <p>{'Create or manage marketing affiliates'}</p>
      <SearchTable
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ ADD`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={affiliates}
        tableConfig={tableConfig}
        createPermission={createAllowed}
        type={'affiliates'}
      />

      {openModal && (
        <AffiliatesCreationModal
          openModal={openModal}
          onCancel={() => setOpenModal(false)}
          createCallback={addAffiliates}
          updateCallback={editAffiliates}
          roleList={getRoleList()}
          data={selectedAffiliate}
        />
      )}
      {resetPasswordModal && (
        <ResetPasswordModal
          user={{ _id: selectedAffiliate.user_id }}
          showModal={resetPasswordModal}
          handleClose={() => setResetPasswordModal(false)}
        />
      )}
      {affiliateStatusModal && (
        <CModal
          size="md"
          visible={true}
          alignment="center"
          onClose={() => setAffiliateStatusModal(false)}
        >
          <CModalHeader closeButton>
            {selectedAffiliate.status ? 'Deactivate' : 'Activate'} {selectedAffiliate.name}
          </CModalHeader>
          {selectedAffiliate.status && (
            <CModalBody>
              After deactivation affiliate will not able to login and all the discount code also
              will not be applicable.
              <br /> Do you want to deactivate?
            </CModalBody>
          )}
          {!selectedAffiliate.status && (
            <CModalBody>Do you want to activate the Affiliate?</CModalBody>
          )}
          <CModalFooter>
            <CButton color="primary" onClick={() => handleStatus(selectedAffiliate)}>
              {selectedAffiliate.status ? 'Deactivate' : 'Activate'}
            </CButton>{' '}
            <CButton color="secondary" onClick={() => setAffiliateStatusModal(false)}>
              Cancel
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  )
}

export default Affiliates
